import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService, BaseComponent, BaseComponentMode, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { SalesManagerOrdersService } from "./salesmanagerorders.service";
import { TranslateService } from "@ngx-translate/core";
import { SalesmanagerOrderDetails } from "../../api-models/SalesManagerOrder";
import { SalesManagerShopItemCategory, SalesManagerShopItemCategoryArray } from "@impacgroup/ayyildiz-checklist-platform-api-dtos";
import { saveAs } from "file-saver";
import moment from "moment";

@Component({
    selector: "app-salesmanagerorderdetail",
    templateUrl: "./salesmanagerorderdetail.component.html",
    styleUrls: ["salesmanagerorderdetail.component.scss"],
    standalone: false
})
export class SalesManagerOrderDetailComponent extends BaseComponent implements OnInit {
    private salesManagerOrderId: string = null;
    public salesManagerOrder: SalesmanagerOrderDetails = null;

    public displayedColumns: string[] = ["materialNumber", "name", "category", "quantity"];

    constructor(
        private route: ActivatedRoute,
        private salesManagerOrdersService: SalesManagerOrdersService,
        private router: Router,
        private alertService: AlertService,
        private translateService: TranslateService,
        private _location: Location
    ) {
        super();

        this.subscriptions.push(
            this.route.params.subscribe((params) => {
                this.salesManagerOrderId = params.id;
                if (this.salesManagerOrderId) {
                    this.initDetails();
                } else {
                    this.back();
                }
            })
        );
    }

    ngOnInit(): void {}

    initDetails() {
        this.subscriptions.push(
            this.salesManagerOrdersService.readSalesManagerOrder(this.salesManagerOrderId).subscribe(
                (result) => {
                    this.salesManagerOrder = result;
                },
                (err) => {
                    this.router.navigate(["../"], { relativeTo: this.route });
                }
            )
        );
    }

    back() {
        this._location.back();
    }

    downloadSalesManagerOrdersCSV() {
        this.subscriptions.push(
            this.salesManagerOrdersService.downloadSalesManagerOrderCSV(this.salesManagerOrderId).subscribe((salesManagerOrdersCSVBlob) => {
                const fileName = `order_vo${this.salesManagerOrder.distributor.vo}_${moment(this.salesManagerOrder.created).utc().format("YYYY-MM-DD_HH-mm-ss")}.csv`;
                saveAs(salesManagerOrdersCSVBlob, fileName);
            })
        );
    }
}
